import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=9be0865c&scoped=true&lang=pug&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.scss?vue&type=style&index=0&id=9be0865c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be0865c",
  null
  
)

export default component.exports